import { useTranslation } from 'react-i18next';

import Chip from 'components/Chip/Chip';

export enum ConversationsFilterEnum {
  All = 'all',
  Unread = 'unread',
  Groups = 'groups',
}

type ConversationsChipProps = {
  filter: ConversationsFilterEnum;
  isActive: boolean;
  onClick: () => void;
};

const ConversationsChip = ({ filter, isActive, onClick }: ConversationsChipProps) => {
  const { t } = useTranslation();

  return (
    <Chip isActive={isActive} onClick={onClick}>
      {t(`messenger.filters.${filter}`)}
    </Chip>
  );
};

export default ConversationsChip;
